<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<a id="page4"></a>
<p class="center2"><span class="CharOverride-6">LIVE LIFE TO THE FULL</span></p>
<p class="center0"><span class="CharOverride-6">LOVE YOUR LIFE</span></p>
<p class="center0"><span class="CharOverride-6">LAUGH WITH YOUR WHOLE HEART</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?1a92bbc3